var _rect, _circle, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 13.3333,
    rx: 6.66667,
    transform: "matrix(1 0 0 -1 1.33325 14.667)",
    fill: "#CCCCD9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 0.8,
    cy: 0.8,
    r: 0.8,
    transform: "matrix(1 0 0 -1 7.19995 5.06641)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.6,
    height: 5.86667,
    rx: 0.8,
    transform: "matrix(1 0 0 -1 7.19995 12)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/information-icon.43df8221.svg";
export { ForwardRef as ReactComponent };